import { INSTANCE_VIEW_READ } from 'client/redux/instance/constants';
import * as actionCreators from 'client/redux/instance/actionCreators';

export const instanceViewRead = id => dispatch => {
  return dispatch(actionCreators.instanceReadView(INSTANCE_VIEW_READ, id));
};
